module.exports = __webpack_public_path__ + "assets/img/title-7aa863a2.png";